import React from 'react'
import {findDOMNode} from "react-dom"
import PopoverComponent, {PopoverComponentProps, PopoverComponentState} from "../base-component/popover-component"

import Popover from '../gd-popover/popover-v2'
import PopoverPosition from '../gd-popover/popover-position'
import HealthIcon from "./health-icon/health-icon"

type Props = PopoverComponentProps & {
    value?              : any

    size?               : '14'|'20'

    disabled?           : boolean

    attachment?         : string
    targetAttachment?   : string

    className?          : string
    type?               : string // referenced by render() but never declared as a public prop upstream - kept for parity, see migration notes

    onChange?           : callback
}

type State = PopoverComponentState & {
    value : any
}

export default class HealthSelector extends PopoverComponent<Props, State> {
    static defaultProps: Partial<Props> = {
        size            : '20',
        disabled        : false,
        attachment      : "top center",
        targetAttachment: "bottom center",
    }

    state: State = {
        showPopover: false,
        value: this.props.value
    }

    componentDidUpdate(prevProps:Props) {
        if (prevProps.value !== this.props.value && this.state.value !== this.props.value) {
            this.setState({
                value: this.props.value,
            })
        }
    }

    onSelectValue = (value:any) => {
        this.setState({
            showPopover: false,
            value: value
        }, ()=>{
            if (this.props.onChange) this.props.onChange(value.toString())
        })
    }

    renderPopover = () => {
        if (this.state.showPopover) {
            const popoverPosition = new PopoverPosition({
                attachment      : this.props.attachment,
                targetAttachment: this.props.targetAttachment,
            })

            return (
                <Popover className="gd-popover-health-selector-content"
                         popoverClass="gd-popover-health-selector"
                         position={popoverPosition}
                         getTargetFunc={()=>findDOMNode(this)}
                         onClickOutside={()=>{this.hidePopover()}}>
                    {[0,1,2].map((value, key)=><HealthIcon key={key} className="health-option" value={value} onClick={this.onSelectValue}/>)}
                </Popover>
            )
        } else {
            return null
        }
    }

    render() {
        const classes = Classes('gd-health-selector', this.props.type+"-type", this.props.className, {
            disabled: this.props.disabled
        })

        return (
            <div className={classes} onClick={this.props.disabled ? null : this.showPopover}>
                <HealthIcon size={this.props.size} value={this.state.value}/>
                {this.renderPopover()}
            </div>
        )
    }
}
